import { IExlySearchableDropdownOption } from "../../Form/modules/ExlySearchableDropdown/ExlySearchableDropdown.interfaces";
import { indian_states_and_uts } from "../constants/indianStatesUtsData";

export const getFormattedIndianStates = () => {
    const indian_states_and_uts_dropdown_map: {
        [key: string]: IExlySearchableDropdownOption;
    } = {};
    indian_states_and_uts.forEach((item, idx) => {
        indian_states_and_uts_dropdown_map[item.name] = {
            id: `${item.name}-${idx}`,
            label: item.name,
            selectedLabel: item.name,
            value: item.name,
        };
    });

    return {
        indian_states_and_uts_dropdown_map,
    };
};
